import { Box, Typography } from "@material-ui/core";
import { Cursor } from "phosphor-react";

const CommentPlaceholder = () => {
  return (
    <Box
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "18px",
        }}
      >
        <Cursor size={24} color="#B1B5C9" />
        <Typography color="#B1B5C9" fontSize={14} fontWeight={400}>
          Click on a shot to view comments
        </Typography>
      </div>
    </Box>
  );
};

export default CommentPlaceholder;
